// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"EM-z","carouselContainer":"FM-z"};